import React, { Component } from "react";
import axios from "axios";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import { FaSearch, FaTimesCircle } from "react-icons/fa";
import { Flex, InputRightElement } from "@chakra-ui/react";
import { t } from "i18next";
import TldrInputWithAddon from "./TldrInputWithAddon";

class TldrSearch extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.onSearchTextChange = this.onSearchTextChange.bind(this);
    this.searchTimeInterval = 500;
    this.search = this.search.bind(this);
    this.throttledSearch = _.debounce(this.search, this.searchTimeInterval);
    this.timeout = 0;
    this.state = {
      searchText: "",
    };
  }

  componentDidMount() {
    var querySearchParam = queryString.parse(this.props.location.search).search;
    this.setState({
      searchText: querySearchParam,
    });
  }

  render() {
    const { searchText } = this.state;

    const {
      placeholder,
      width,
      autoFocus,
      borderRightRadius,
      size,
      height,
      addonLeftChildren,
      searchInputSx,
    } = this.props;

    return (
      <>
        <Flex
          m="0"
          maxWidth="700px"
          justifyContent="start"
          w={width}
          size={size}
          h={height}
        >
          <TldrInputWithAddon
            borderRightRadius={borderRightRadius}
            addonLeftChildren={
              addonLeftChildren ? addonLeftChildren : <FaSearch color="white"/>
            }
            value={searchText ? searchText : ""}
            placeholder={placeholder ? placeholder : ""}
            onChange={this.onSearchTextChange}
            onFocus={(text) => this.onSearchFocus(text)}
            onBlur={this.onSearchBlur}
            onKeyUp={this.onSearchKeyUp}
            autoFocus={autoFocus}
            addonRightChildren={
              searchText &&
              searchText.length > 0 && (
                <InputRightElement
                  children={<FaTimesCircle />}
                  onClick={() => {
                    this.clearSearch();
                  }}
                />
              )
            }
            searchInputSx={searchInputSx}
          />
        </Flex>
      </>
    );
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  search = (searchText) => {
    this.props.onSearch(searchText);
  };

  onSearchTextChange = (value) => {
    var searchText = value; // this is the search text
    this.setState({
      searchText,
    });

    this.throttledSearch(searchText);
  };

  clearSearch = (event) => {
    this.setState(
      {
        searchText: "",
      },
      () => {
        if (this.props.onClear) {
          this.props.onClear(this.state.searchText);
        } else {
          this.props.onSearch(this.state.searchText);
        }
      }
    );
  };

  onSearchFocus = (e) => {
    if (this.props.onFocus) {
      this.props.onFocus(this.state.searchText);
    }
  };

  onSearchBlur = (e) => {
    if (this.props.onBlur) {
      this.props.onBlur(this.state.searchText);
    }
  };

  onSearchKeyUp = (e) => {
    switch (e.keyCode) {
      // esc
      case 27:
        if (this.props.handleEscKeyEvent) {
          this.props.handleEscKeyEvent();
        }
        break;
      // enter
      case 13:
        if (this.props.handleEnterKeyEvent) {
          this.props.handleEnterKeyEvent(this.state.searchText);
        }
        break;
      default:
        break;
    }
  };
}

TldrSearch.propTypes = {};

TldrSearch.defaultProps = {
  placeholder: t("search.search_placeholder", { ns: "common" }),
  width: "640px",
  location: "dashboard",
  searchInputSx: {},
};

export default withRouter(TldrSearch);
